import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@/store/hooks';

/**
 * 인증 보호 라우트 - currentUser가 없으면 /login으로 리다이렉트
 */
interface ProtectedRouteProps {
  children: React.ReactNode;
}

function ProtectedRoute({ children }: ProtectedRouteProps) {
  const currentUser = useAppSelector((s) => s.envs.currentUser);
  const env = useAppSelector((s) => s.envs.env);

  // 환경 정보 로딩 중이면 아직 판단하지 않음
  if (!env) return null;

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

export default ProtectedRoute;
